import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FixedPage from './layout/FixedPage';
import { PageTitle, SimpleButton } from 'react-fast-ui';

const ESC_KEYCODE = 27;
const ENTER_KEYCODE = 13;

export default class NotFoundPage extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  static propTypes = {};

  // lifecycle
  componentDidMount() {
    this.refs.back.focus();
  }

  componentDidUpdate() {
    this.refs.back.focus();
  }

  backToHome = () => this.context.router.push('/');

  // handlers
  handleKeyDown = (e: SyntheticEvent) => {
    switch (e.keyCode) {
      case ESC_KEYCODE:
      case ENTER_KEYCODE:
        this.backToHome();
        break;
      default:
        break;
    }
  };

  render() {
    return (
      <PageTitle title="404 Not Found">
        <FixedPage className="justify-content-center">
          <div onKeyDown={this.handleKeyDown}>
            <p className="mg-top-md mg-bottom-none" style={{ textAlign: 'center' }}>
              Hmm...it seems that there is no page here. Double check the url,
              or just hit the button to go back to the home page.
            </p>
            <div className="display-flex justify-content-center align-items-center" style={{ height: 80 }}>
              <SimpleButton ref="back" tabIndex="1" onClick={this.backToHome}>
                Back to Home Page
              </SimpleButton>
            </div>
          </div>
        </FixedPage>
      </PageTitle>
    );
  }
}